import React, { Fragment, useEffect, useState } from "react";
import {
  useExpanded,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { Button, CardBody, Col, Input, Row, Table } from "reactstrap";

const TableComponent = ({ fetchData, columns, data, count, renderFilter }) => {
  const [controlledPageIndex, setControlledPageIndex] = useState(0);
  const [controlledPageSize, setControlledPageSize] = useState(15);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      manualPagination: true,
      initialState: {
        pageIndex: controlledPageIndex,
        pageSize: controlledPageSize,
      },
      pageCount: Math.ceil(count / controlledPageSize), 
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const dynamicPageCount = Math.ceil(count / (pageSize || 15));

  useEffect(() => {
    setControlledPageIndex(pageIndex);
    setControlledPageSize(pageSize);
  }, [pageIndex, pageSize]);

  useEffect(() => {
    fetchData({ pageIndex: controlledPageIndex, pageSize: controlledPageSize });
  }, [controlledPageIndex, controlledPageSize]);

  const onChangePageSize = (e) => {
    const newSize = Number(e.target.value);
    setPageSize(newSize);
    gotoPage(0); // reset ke halaman pertama
  };

  const onChangePageInput = (e) => {
    const val = e.target.value ? Number(e.target.value) - 1 : 0;
    gotoPage(val);
  };

  return (
    <div className="border-top">
      <Row className="mb-3">
        <CardBody className="border border-top-0 border-end-0 border-start-0">
          <Row>
            <Col sm={1}>
              <div className="me-2 mb-3 col-12">
                <select
                  className="form-select"
                  value={pageSize}
                  onChange={onChangePageSize}>
                  {[15, 25, 50, 100].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      {pageSize}
                    </option>
                  ))}
                </select>
              </div>
            </Col>
            {renderFilter && renderFilter()}
          </Row>
        </CardBody>
      </Row>
      <div
        className="table-responsive table-card mb-1"
        style={{ minHeight: "320px" }}
      >
        <Table hover {...getTableProps()} className="align-middle table-nowrap">
          <thead className="table-light">
            {headerGroups.map((headerGroup, index) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={`${headerGroup.id}-${index}`}>
                {headerGroup.headers.map((column, idx) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={`${column.id}-${idx}`}> 
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <Fragment key={`${row.id}-${index}`}>
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell, idx) => (
                      <td {...cell.getCellProps()} key={`${cell.column.id}=${idx}`}>
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                </Fragment>
              );
            })}
          </tbody>
        </Table>
      </div>

      <Row className="justify-content-md-end justify-content-center align-items-center p-2">
        <Col className="col-md-auto d-none d-md-block">
          {count} Data
        </Col>
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              className="btn btn-light"
              onClick={() => previousPage()}
              disabled={!canPreviousPage}>
              {"<"}
            </Button>
          </div>
        </Col>
        <Col className="col-md-auto d-none d-md-block">
          Halaman  <strong>{pageIndex + 1}</strong> dari 
          <strong>{dynamicPageCount}</strong>
        </Col>
        <Col className="col-md-auto">
          <Input
            type="number"
            min={1}
            style={{ width: 70 }}
            value={pageIndex + 1}
            onChange={onChangePageInput} />
        </Col>
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              className="btn btn-light"
              onClick={() => nextPage()}
              disabled={!canNextPage}>
              {">"}
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default TableComponent;
